import React from 'react';
import WorkImg from '../assets/workImg.jpeg';
import wether from "../assets/wether.png"
import realEstate from '../assets/realestate.jpg';
import you from "../assets/you.png"
import ombd from "../assets/ombd.png"
import fp from "../assets/fp.png"
import kim from "../assets/kim.png"
import orbit from "../assets/orbit.png"
import Typewriter from "typewriter-effect"
import Worknew from './Worknew';
import "./work.css"

const Work = () => {
  return (

<div>
<div id="mainwork" name='work' className=' text-gray-300 bg-[#0a192f]'>
            
              <Worknew/>
   </div>

</div>

  );
};

export default Work;
